import { Card, Input, Select } from 'antd';
import { TextAreaProps } from 'antd/lib/input';
import { DefaultOptionType, SelectProps } from 'antd/lib/select';
import React, { useEffect, useState } from 'react';

type ElementType = HTMLTextAreaElement | null;

interface Props extends Omit<TextAreaProps, 'onChange'> {
  onChange?: (value: string) => void;
  value?: string;
  tags: DefaultOptionType[];
  selectProps?: SelectProps;
}

const TextareaVars = React.forwardRef<ElementType, Props>(
  ({ tags, selectProps, ...props }, ref) => {
    const [pointer, setPointer] = useState<[number | null, number | null]>([
      null,
      null,
    ]);
    const [value, setValue] = useState('');

    useEffect(() => {
      setValue(props.value || '');
    }, [props.value]);

    function setVar(text: string) {
      const indexStart = pointer[0] || value.length;
      const indexEnd = pointer[1] || value.length;

      const newValue =
        value.substring(0, indexStart) + text + value.substring(indexEnd);

      setValue(newValue);

      if (props.onChange) {
        props.onChange(newValue);
      }
    }

    return (
      <Card bodyStyle={{ padding: 16 }}>
        <Select
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          {...selectProps}
          style={{
            width: 'auto',
            minWidth: 200,
            marginBottom: 16,
            ...selectProps?.style,
          }}
          placeholder={selectProps?.placeholder || 'Selecionar tag'}
          onChange={setVar}
          options={tags}
          value={null}
        />

        <Input.TextArea
          {...props}
          value={value}
          ref={ref}
          onChange={(event) => {
            setPointer([
              event.target.selectionStart,
              event.target.selectionEnd,
            ]);

            setValue(event.target.value);

            if (props.onChange) {
              props.onChange(event.target.value);
            }
          }}
          onSelect={(event) => {
            setPointer([
              event.currentTarget.selectionStart,
              event.currentTarget.selectionEnd,
            ]);

            !!props.onSelect && props.onSelect(event);
          }}
        />
      </Card>
    );
  },
);

export default TextareaVars;
